import { IAddress } from '@commenda/types';
import { BaseFileType } from '@commenda/types/src/file/types';
import { EducationalQualificationEnum } from '@commenda/types/src/random';
import { DirectorBase } from '@commenda/types/src/work-request/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export type DirectorReturnType = DirectorBase & {
  WorkRequests: {
    id: string;
  }[];
  governmentId: BaseFileType;
  aadharCard: BaseFileType;
  panCard: BaseFileType;
  addressProof: BaseFileType;
  operatingAddress: IAddress;
  personalDetails?: {
    hasDSC?: boolean;
    educationalQualification?: EducationalQualificationEnum;
  };
  mailingAddress: IAddress;
  directorIdentificationNumber?: string;
  stakeholder: { id: string };
};

export function useGetAllDirectorsInCompany(companyId: number) {
  const {
    data,
    mutate,
    error,
    isLoading,
  }: {
    data?: { directors: DirectorReturnType[] };
    error?: unknown;
    isLoading: boolean;
    mutate?: KeyedMutator<unknown>;
  } = useSWR(
    `director/byCompany/${companyId}`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    mutate,
    error,
    isLoading,
  };
}
